module.exports = __webpack_public_path__ + "static/media/united-kingdom.bd640a98.png";